import { Dimensions } from 'react-native-web';

const { width, height } = Dimensions.get('window');

const globalData = {
    BLANK_LOADED: false,
    APP_NAME: 'Truckster Vendor',
    PRODUCTION_LINK: 'https://api.gotruckster.com/api',
    DEV_LINK: 'https://api-dev.gotruckster.com/api',
    FATHER_LINK: process.env.REACT_APP_IS_DEV === 'true' ? 'https://api-dev.gotruckster.com/api' : 'https://api.gotruckster.com/api',

    WIDTH: width,
    HEIGHT: height,
    TAB_BAR_HEIGHT: 52,
    COMPONENT: {
        SEGMENT_HEIGHT: 30
    },
    COLOR: {
        MAIN: 'rgb(250, 57, 61)',
        MAIN_SELECTED: 'rgba(250, 57, 61, 0.2)',
        MAIN_HEX: '#fa393d',
        MAIN_BACKGROUND: '#EDEDED',
        BACKGROUND_GREY: 'rgb(237, 239, 242)',
        INNER_GRAY: 'rgb(237, 237, 237)',
        TEXT_GRAY: 'rgb(125, 131, 150)',
        TEXT_LIGHT_GRAY: 'rgba(125, 131, 150, 0.5)',
        FACEBOOK: 'rgb(40, 103, 176)',
        TWITTER: 'rgb(98, 178, 238)',
        INSTAGRAM: 'purple',
        GOOGLE: 'rgb(206, 85, 63)',
        BACKGROUND: '#FAFAFA',
        DIVIDER: 'rgba(0, 0, 0, 0.1)',
        BASIC: {
            ORANGE: 'rgb(226, 100, 55)',
            RED: 'rgb(237, 59, 59)',
            BROWN_RED: 'rgb(154, 53, 48)',
            GREEN: 'rgb(0, 174, 119)',
            GREEN_HEX: '#00ae77',
            BLUE: 'rgb(3, 155, 229)',
            DARK_BLUE: 'rgb(51, 93, 141)',
            GRAY: 'rgb(152, 166, 180)',
            LIGHT_GRAY: 'rgb(248, 248, 248)',
            PURPLE: 'rgb(105, 50, 143)',
            WARM_GREY: 'rgb(117, 117, 117)',
            WHITE_TWO: 'rgb(239, 239, 239)',
            WHITE_THREE: 'rgb(239, 239, 239)',
            GOLD: 'rgb(249, 211, 113)',
            PINKISH_GREY: '#bdbdbd',
            BLACK_TWO: 'rgb(33, 33, 33)',
            ALTO_GREY: 'rgb(218, 218, 218)',

            MAIN_BLACK: '#212121',
            COVER_GRAY: '#DADADA',
            MAIN_GRAY: '#757575',
            LIGHT_BLACK_TWO: 'rgba(33, 33, 33, 0.05)',
            COMPLETE_GREEN: '#3EC7A2',
            LIGHT_PINK: 'rgba(250, 57, 61, 1.0)',
            DODGER_BLUE: 'rgb(82, 137, 255)',
            LIGHT_WHITE: 'rgba(218, 218, 218, 1.0)',
            LIGHTER_WHITE: 'rgba(235,235,235,1.0)',
            WHITE_BACKGROUND: 'rgb(250,250,250)',
            STRAWBERRY_TWO: 'rgb(243, 33, 38)',
            GREENISH_TEAL: '#32d770',
            STRAWBERRY: 'rgb(250, 57, 61)',
            LIGHT_GOLD: 'rgb(255, 211, 94)',
            GRAY_OPAQUE: 'rgba(33, 33, 33, 0.4)',
            BROWNISH_GREY: 'rgb(117, 117, 117)',
            DARK_MINT: 'rgb(50, 215, 112)',

            NEUTRAL_DARK_GREY: 'rgb(66, 66, 66)',
            NEUTRAL_GREY: 'rgb(102, 102, 102)',
            NEUTRAL_LIGHT_GREY: 'rgb(161, 161, 161)',
            NEUTRAL_STROKE: 'rgb(212, 212, 212)',

            UI_YELLOW: 'rgb(255, 166, 0)',
            UI_BLUE: 'rgb(0, 117, 219)',
            UI_GREEN: 'rgb(118, 192, 33)'
        }
    },

    DATA: {
        LOGIN_SERVICE: null,
        USER_TOKEN: null,
        USER: {
            name: '',
            email: '',
            phone: '',
            avatar: null,
            gender: 0,
            birthday: 850150800
        },
        SALES_TAX_OPTIONS: {},
        SIGNUP_USER: {
            logo: null,
            name: '',
            phone: '',
            email: '',
            website: '',
            facebook: '',
            instagram: '',
            twitter: '',
            cuisine: '',
            locationId: '',
            legalName: '',
            merchantId: '',
            squareToken: '',
            squareExpiresAt: ''
        },

        TRUCK_DATA: {},

        CACHED_LOCATION: [],

        CACHED_EVENT_LIST: [],
        CACHED_MESSAGE_LIST: []
    },

    CUISINE_LIST: [],

    CACHE: {
        ORDERS: {}
    },

    SETTINGS: {
        MAX_CATERING_TRUCKS: 3
    },

    FACEBOOK: {
        TOKEN: ''
    },
    GOOGLE: {
        TOKEN: '',
        AVAILABLE: false
    },

    BUGSNAG: null,

    BRAZED_INITIATED: false,
    BRAZE_DATA: {
        contentCards: []
    },

    CURRENT_TAB_NAME: 'Profile',

    MAIN: null,
    MAIN_TAB_BAR: null,

    SPLASH: null,
    PROFILE: null,
    DASHBOARD: null,
    ORDERS: null,
    ORDERS_CONFIG: {
        openSettings: false
    },
    ORDERS_LOADING: false,
    CURRENT_ORDER_DETAIL: null,
    MENU: null,
    CATERING: null,
    MORE: null,
    LOGIN: null,
    SWITCH_ACCOUNT_SCREEN: null,
    REVIEWS: null,
    FORUM: null,
    CURRENT_FORUM_DETAIL: null,

    CATERING_JUMP_TO_HOOD: false,
    OPEN_PAST_CATERING_MODAL: false,
    CURRENT_CATERING_DETAIL: null,
    CURRENT_HOOD_DETAIL: null,

    SLACK_HOOKS: {
        TIER_UPGRADE: '',
        ZERO_BOUNCE: 'https://hooks.slack.com/services/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'
    },

    CITIES: {},
    GROUPED_STATES: []
};

export default globalData;
